import { create } from 'zustand';
import { createConversationsListSlice } from '../conversations-list/store/index.slice';
import { ConversationsListSlice } from '../conversations-list/store/index.types';
import { createConversationsCreateSlice } from '../createConversation/store/index.slice';
import { ConversationsCreateSlice } from '../createConversation/store/index.types';
import { createTypingIndicatorSlice } from '../typing-indicator/store/index.slice';
import { TypingIndicatorSlice } from '../typing-indicator/store/index.types';
import { createHistorySlice } from './history-legacy/index.slice';
import { HistoryConversationsSlice } from './history-legacy/index.types';
import { createConversationMentionsSlice } from './mentions/index.slice';
import { ConversationMentionsSlice } from './mentions/index.types';
import { createOptOutSlice } from './opt-out/index.slice';
import { OptOutSlice } from './opt-out/index.types';
import { createPinnedConversationsSlice } from './pinned-conversations/index.slice';
import { PinnedConversationsSlice } from './pinned-conversations/index.types';

export const useConversationStore = create<
  HistoryConversationsSlice &
    OptOutSlice &
    ConversationMentionsSlice &
    ConversationsListSlice &
    ConversationsCreateSlice &
    PinnedConversationsSlice &
    TypingIndicatorSlice
>()((...a) => ({
  ...createHistorySlice(...a),
  ...createOptOutSlice(...a),
  ...createConversationMentionsSlice(...a),
  ...createConversationsListSlice(...a),
  ...createConversationsCreateSlice(...a),
  ...createPinnedConversationsSlice(...a),
  ...createTypingIndicatorSlice(...a),
}));
